module.exports = __webpack_public_path__ + "img/sense-logo.b27f3970.png";